module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_automatic_frame-72c614d0b590cc70afa32e337eca9eb4.png";